import { trackEventGA4 } from './track-event-GA4';
import {
  PAGE_TYPES,
  EVENT_NAMES,
  EVENT_CATEGORIES,
  PAGE_SECTIONS,
} from './constants';

const extractCategoryParams = (category) => ({
  category_1_id: category?.breadcrumbs?.[0]?.id || '',
  category_1_name: category?.breadcrumbs?.[0]?.name || '',
  category_2_id: category?.breadcrumbs?.[1]?.id || '',
  category_2_name: category?.breadcrumbs?.[1]?.name || '',
  category_3_id: category?.breadcrumbs?.[2]?.id || '',
  category_3_name: category?.breadcrumbs?.[2]?.name || '',
});


export const pageViewDashboardEvent = () => {
  trackEventGA4({
    category: EVENT_CATEGORIES.PAGEVIEW,
    action: EVENT_NAMES.PAGE_VIEW,
    params: {
      page_type: PAGE_TYPES.DASHBOARD,
      page_section: PAGE_SECTIONS.HEADER
    },
  });
};

// this Action will work on all page type headers as this component is rendered only in app.jsx
export const manageOrdersHeaderClickEvent = (sourcePage) => {
  trackEventGA4({
    category: EVENT_CATEGORIES.CLICK,
    action: EVENT_NAMES.MANAGE_ORDERS,
    params: {
      page_type: sourcePage,
      page_section: PAGE_SECTIONS.HEADER
    },
  });
}

export const addProductHeaderClickEvent = (sourcePage) => {
  trackEventGA4({
    category: EVENT_CATEGORIES.CLICK,
    action: EVENT_NAMES.ADD_PRODUCT,
    params: {
      page_type: sourcePage,
      page_section: PAGE_SECTIONS.HEADER,
    },
  });
}

export const pendingOrdersViewDetailClickEvent = () => {
  trackEventGA4({
    category: EVENT_CATEGORIES.CLICK,
    action: EVENT_NAMES.ORDER_DETAILS,
    params: {
      page_type: PAGE_TYPES.DASHBOARD,
      page_section: PAGE_SECTIONS.PENDING_ORDERS,
    },
  })
}

export const updateStockActionClickEvent = (category, pagination, errorMessage = null) => {
  const params = {
    page_type: PAGE_TYPES.MANAGE_PRODUCTS,
    page_section: PAGE_SECTIONS.PRODUCT_LISTING,
    page_number: pagination?.current_page ?? '',
    page_count: pagination?.total_pages ?? '',
    ...extractCategoryParams(category),
  };
  if (errorMessage) {
    const errorMsg = errorMessage;
    params.error_message = String(errorMsg);
  }
  trackEventGA4({
    category: EVENT_CATEGORIES.CLICK,
    action: EVENT_NAMES.UPDATE_STOCK,
    params,
  })
}

export const editProductActionClickEvent = (category, pagination, errorMessage = null) => {
  const params = {
    page_type: PAGE_TYPES.MANAGE_PRODUCTS,
    page_section: PAGE_SECTIONS.PRODUCT_LISTING,
    page_number: pagination?.current_page ?? '',
    page_count: pagination?.total_pages ?? '',
    ...extractCategoryParams(category),
  };
  if (errorMessage != null && errorMessage !== '') {
    const errorMsg = errorMessage?.error?.message || errorMessage?.message || errorMessage;
    params.error_message = String(errorMsg);
  }
  trackEventGA4({
    category: EVENT_CATEGORIES.CLICK,
    action: EVENT_NAMES.EDIT_PRODUCT,
    params,
  })
}

export const deactivateProductActionClickEvent = (category, pagination, errorMessage = null) => {
  const params = {
    page_type: PAGE_TYPES.MANAGE_PRODUCTS,
    page_section: PAGE_SECTIONS.PRODUCT_LISTING,
    page_number: pagination?.current_page ?? '',
    page_count: pagination?.total_pages ?? '',
    ...extractCategoryParams(category),
  };
  if (errorMessage != null && errorMessage !== '') {
    const errorMsg = errorMessage?.error?.message || errorMessage?.message || errorMessage;
    params.error_message = String(errorMsg);
  }
  trackEventGA4({
    category: EVENT_CATEGORIES.CLICK,
    action: EVENT_NAMES.DELETE_PRODUCT,
    params,
  })
}

export const shareProductActionClickEvent = (category, pagination) => {
  
  trackEventGA4({
    category: EVENT_CATEGORIES.CLICK,
    action: EVENT_NAMES.SHARE_PRODUCT,
    params: {
      page_type: PAGE_TYPES.MANAGE_PRODUCTS,
      page_section: PAGE_SECTIONS.PRODUCT_LISTING,
      page_number: pagination?.current_page ?? '',
      page_count: pagination?.total_pages ?? '',
      ...extractCategoryParams(category),
    },
  })
}

export const searchFilterClickEvent = (filters) => {
  trackEventGA4({
    category: EVENT_CATEGORIES.CLICK,
    action: EVENT_NAMES.SEARCH,
    params: {
      page_type:  location?.pathname?.split("/")?.pop() || '',
      filters_list: filters && typeof filters === 'object' ? JSON.stringify(filters) : '',
    },
  })
}

export const manageProductsPageViewEvent = () => {
  trackEventGA4({
    category: EVENT_CATEGORIES.PAGEVIEW,
    action: EVENT_NAMES.PAGE_VIEW,
    params: {
      page_type: PAGE_TYPES.MANAGE_PRODUCTS,
      page_section: PAGE_SECTIONS.PRODUCT_LISTING,
    },
  })
}

export const productSubmitClickEvent = (category, ID, errorMessage = null) => {
  const params = {
    page_type: PAGE_TYPES.ADD_PRODUCT,
    page_section: PAGE_SECTIONS.FORM,
    category_1_id: category?.parent?.id || '',
    category_1_name: category?.parent?.name || '',
    category_2_id: category?.child?.id || '',
    category_2_name: category?.child?.name || '',
    category_3_id: category?.subChild?.id || '',
    category_3_name: category?.subChild?.name || '',
  };
  if (errorMessage != null && errorMessage !== '') {
    const errorMsg = errorMessage?.error?.message || errorMessage?.message || errorMessage;
    params.error_message = String(errorMsg);
  }
  trackEventGA4({
    category: EVENT_CATEGORIES.CLICK,
    action: ID ? EVENT_NAMES.UPDATE_PRODUCT : EVENT_NAMES.SUBMIT_PRODUCT,
    params,
  })
}

export const addUserClickEvent = (pagination, errorMessage = null) => {
  const params = {
    page_type: PAGE_TYPES.MANAGE_USERS,
    page_section: PAGE_SECTIONS.USER_LISTING,
    page_number: pagination?.current_page ?? '',
    page_count: pagination?.total_pages ?? '',
  };
  if (errorMessage != null && errorMessage !== '') {
    const errorMsg = errorMessage?.error?.message || errorMessage?.message || errorMessage;
    params.error_message = String(errorMsg);
  }
  trackEventGA4({
    category: EVENT_CATEGORIES.CLICK,
    action: EVENT_NAMES.ADD_USER,
    params,
  })
}

export const removeUserClickEvent = (pagination, errorMessage = null) => {
  const params = {
    page_type: PAGE_TYPES.MANAGE_USERS,
    page_section: PAGE_SECTIONS.USER_LISTING,
    page_number: pagination?.current_page ?? '',
    page_count: pagination?.total_pages ?? '',
  };
  if (errorMessage != null && errorMessage !== '') {
    const errorMsg = errorMessage?.error?.message || errorMessage?.message || errorMessage;
    params.error_message = String(errorMsg);
  }
  trackEventGA4({
    category: EVENT_CATEGORIES.CLICK,
    action: EVENT_NAMES.REMOVE_USER,
    params,
  })
}

export const editUserClickEvent = (pagination, errorMessage = null) => {
  const params = {
    page_type: PAGE_TYPES.MANAGE_USERS,
    page_section: PAGE_SECTIONS.USER_LISTING,
    page_number: pagination?.current_page ?? '',
    page_count: pagination?.total_pages ?? '',
  };
  if (errorMessage != null && errorMessage !== '') {
    const errorMsg = errorMessage?.error?.message || errorMessage?.message || errorMessage;
    params.error_message = String(errorMsg);
  }
  trackEventGA4({
    category: EVENT_CATEGORIES.CLICK,
    action: EVENT_NAMES.EDIT_USER,
    params,
  })
}

export const basicInfoSaveClickEvent = (errorMessage) => {
  const params = {
    page_type: PAGE_TYPES.PROFILE_SETTINGS,
    page_section: PAGE_SECTIONS.FORM,
  };
  if (errorMessage != null && errorMessage !== '') {
    const errorMsg = errorMessage?.error?.message || errorMessage;
    params.error_message = String(errorMsg);
    }
  
  trackEventGA4({
    category: EVENT_CATEGORIES.CLICK,
    action: EVENT_NAMES.BASIC_INFO,
    params,
  })
}

export const warehouseLocationSaveClickEevnt = (errorMessage) => {
  const params = {
    page_type: PAGE_TYPES.PROFILE_SETTINGS,
    page_section: PAGE_SECTIONS.FORM,
  };
  if (errorMessage != null && errorMessage !== '') {
    params.error_message = String(errorMessage);
  }
  
  trackEventGA4({
    category: EVENT_CATEGORIES.CLICK,
    action: EVENT_NAMES.WAREHOUSE_LOC,
    params,
  })
}

export const shipmentsOrderDetailClickEvent = (pagination) => {
  
  trackEventGA4({
    category: EVENT_CATEGORIES.CLICK,
    action: EVENT_NAMES.ORDER_DETAILS,
    params: {
      page_type: PAGE_TYPES.SHIPMENTS,
      page_section: PAGE_SECTIONS.SHIPMENT_LISTING,
      page_number: pagination?.current_page ?? '',
      page_count: pagination?.total_pages ?? '',
    },
  })
}

export const shipmentsShippingLabelClickEvent = (errorMsg, pagination) => {
  const params = {
    page_type: PAGE_TYPES.SHIPMENTS,
    page_section: PAGE_SECTIONS.SHIPMENT_LISTING,
    page_number: pagination?.current_page ?? '',
    page_count: pagination?.total_pages ?? '',
  };
  if (errorMsg != null && errorMsg !== '') {
    params.error_message = String(errorMsg);
  }
  
  trackEventGA4({
    category: EVENT_CATEGORIES.CLICK,
    action: EVENT_NAMES.PRINT_LABEL,
    params,
  })
}

export const reviewsViewOrderClickEvent = () => {
  trackEventGA4({
    category: EVENT_CATEGORIES.CLICK,
    action: EVENT_NAMES.ORDER_DETAILS,
    params: {
      page_type: PAGE_TYPES.REVIEWS,
      page_section: PAGE_SECTIONS.REVIEW_LISTING,
    },
  })
}

export const reviewsReplyClickEvent = (pagination, errorMessage = null) => {
  const params = {
    page_type: PAGE_TYPES.REVIEWS,
    page_section: PAGE_SECTIONS.REVIEW_LISTING,
    page_number: pagination?.current_page ?? '',
    page_count: pagination?.total_pages ?? '',
  };
  if (errorMessage != null && errorMessage !== '') {
    const errorMsg = errorMessage?.error?.message || errorMessage?.message || errorMessage;
    params.error_message = String(errorMsg);
  }
  trackEventGA4({
    category: EVENT_CATEGORIES.CLICK,
    action: EVENT_NAMES.REVIEW_REPLY,
    params,
  })
}

const extractOrderCategoryParams = (order) => {
  const firstLineItem = order?.line_items?.[0];
  const category = firstLineItem?.category;
  const breadcrumbs = category?.breadcrumbs || (category ? [{ id: category?.id, name: category?.name }] : []);
  
  return {
    category_1_id: breadcrumbs?.[0]?.id || '',
    category_1_name: breadcrumbs?.[0]?.name || '',
    category_2_id: breadcrumbs?.[1]?.id || '',
    category_2_name: breadcrumbs?.[1]?.name || '',
    category_3_id: breadcrumbs?.[2]?.id || '',
    category_3_name: breadcrumbs?.[2]?.name || '',
    category_4_id: breadcrumbs?.[3]?.id || '',
    category_4_name: breadcrumbs?.[3]?.name || '',
    filter_value: '', // filter_value not available in order details context
  };
};

export const orderDetailsActionButtonClickEvent = (actionName, order, errorMessage = null) => {
  const params = {
    page_type: PAGE_TYPES.ORDER_DETAILS,
    page_section: PAGE_SECTIONS.ACTION_BUTTONS,
    ...extractOrderCategoryParams(order),
  };
  if (errorMessage != null && errorMessage !== '') {
    const errorMsg = errorMessage?.error?.message || errorMessage?.message || errorMessage;
    params.error_message = String(errorMsg);
  }
  trackEventGA4({
    category: EVENT_CATEGORIES.CLICK,
    action: actionName,
    params,
  })
}

export const addSpecificationClickEvent = (specs) => {
  trackEventGA4({
    category: EVENT_CATEGORIES.CLICK,
    action: 'add_specification',
    params: {
      page_type: PAGE_TYPES.ORDER_DETAILS,
      page_section: PAGE_SECTIONS.FORM,
      specification: specs,
    },
  })
}

export const manageProductsViewPage = () => {
  trackEventGA4({
    category: EVENT_CATEGORIES.PAGEVIEW,
    action: EVENT_NAMES.PAGE_VIEW,
    params: {
      page_type: PAGE_TYPES.MANAGE_PRODUCTS,
      page_section: PAGE_SECTIONS.PRODUCT_LISTING,
    },
  });
}
export const addProductPageView = () => {
  trackEventGA4({
    category: EVENT_CATEGORIES.PAGEVIEW,
    action: EVENT_NAMES.PAGE_VIEW,
    params: {
      page_type: PAGE_TYPES.ADD_PRODUCT,
      page_section: PAGE_SECTIONS.FORM,
    },
  });
}

export const editProductPageView = () => {
  trackEventGA4({
    category: EVENT_CATEGORIES.PAGEVIEW,
    action: EVENT_NAMES.PAGE_VIEW,
    params: {
      page_type: PAGE_TYPES.EDIT_PRODUCT,
      page_section: PAGE_SECTIONS.FORM,
    },
  });
}

export const orderDetailsPageView = () => {
  trackEventGA4({
    category: EVENT_CATEGORIES.PAGEVIEW,
    action: EVENT_NAMES.PAGE_VIEW,
    params: {
      page_type: PAGE_TYPES.ORDER_DETAILS,
      page_section: PAGE_SECTIONS.FORM,
    },
  });
}

export const shipmentsPageView = () => {
  trackEventGA4({
    category: EVENT_CATEGORIES.PAGEVIEW,
    action: EVENT_NAMES.PAGE_VIEW,
    params: {
      page_type: PAGE_TYPES.SHIPMENTS,
      page_section: PAGE_SECTIONS.SHIPMENT_LISTING,
    },
  });
}

export const manageUsersPageView = () => {
  trackEventGA4({
    category: EVENT_CATEGORIES.PAGEVIEW,
    action: EVENT_NAMES.PAGE_VIEW,
    params: {
      page_type: PAGE_TYPES.MANAGE_USERS,
      page_section: PAGE_SECTIONS.USER_LISTING,
    },
  });
}

export const profileSettingsPageView = () => {
  trackEventGA4({
    category: EVENT_CATEGORIES.PAGEVIEW,
    action: EVENT_NAMES.PAGE_VIEW,
    params: {
      page_type: PAGE_TYPES.PROFILE_SETTINGS,
      page_section: PAGE_SECTIONS.FORM,
    },
  });
}

export const manageOrdersActionClickEvent = (actionName, pagination, errorMessage = null, order = null) => {
  const params = {
    page_type: PAGE_TYPES.MANAGE_ORDERS,
    page_section: PAGE_SECTIONS.ORDER_LISTING,
    page_number: pagination?.current_page ?? '',
    page_count: pagination?.total_pages ?? '',
    ...(order ? extractOrderCategoryParams(order) : {}),
  };
  if (errorMessage != null && errorMessage !== '') {
    const errorMsg = errorMessage?.error?.message || errorMessage?.message || errorMessage;
    params.error_message = String(errorMsg);
  }
  trackEventGA4({
    category: EVENT_CATEGORIES.CLICK,
    action: actionName,
    params,
  });
}

export const reviewsPageView = () => {
  trackEventGA4({
    category: EVENT_CATEGORIES.PAGEVIEW,
    action: EVENT_NAMES.PAGE_VIEW,
    params: {
      page_type: PAGE_TYPES.REVIEWS,
      page_section: PAGE_SECTIONS.REVIEW_LISTING,
    },
  });
}

export const manageOrdersPageView = () => {
  trackEventGA4({
    category: EVENT_CATEGORIES.PAGEVIEW,
    action: EVENT_NAMES.PAGE_VIEW,
    params: {
      page_type: PAGE_TYPES.MANAGE_ORDERS,
      page_section: PAGE_SECTIONS.ORDER_LISTING,
    },
  });
}

export const dashboardRecentProductsEditClickEvent = (category) => {
  trackEventGA4({
    category: EVENT_CATEGORIES.CLICK,
    action: EVENT_NAMES.EDIT_PRODUCT,
    params: {
      page_type: PAGE_TYPES.DASHBOARD,
      page_section: PAGE_SECTIONS.RECENT_PRODUCTS,
      ...extractCategoryParams(category),
    },
  })
}